<template>
    <div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <strong>Seleccione las muestras que desea enviar a Enología especificando el motivo</strong>
            </div>
          </div>
        </div>
        <div class="row"> 
          <div class="col">
              <div class="form-group">
                    <div class="card" v-if="detailNew.length > 0">
                        <div class="card-header">
                            <h4>Nuevo Producto</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                        <th style="width: 3%;"></th>
                                        <th style="width: 30%;">Motivo</th>
                                    </tr>
                                </thead>
                                <tbody v-for="dnew in detailNew" :key="dnew.id">
                                    <tr>
                                        <td>{{dnew.brand}}</td>
                                        <td v-if="dnew.comercialMixCode">{{ dnew.comercialMix }} - {{ dnew.comercialMixCode }}</td>
                                        <td v-if="dnew.isNewComposition">Nueva Composición</td>
                                        <td>{{dnew.variety}} {{dnew.valley}} {{dnew.quality}}</td>
                                        <td>{{dnew.finalHarvest}}</td>
                                        <td>{{dnew.quantity}}</td>
                                        <td><input class="form-control" type="checkbox" :id="'check-' + dnew.id" /></td>
                                        <td><textarea class="form-control"  :id="'reason-' + dnew.id" placeholder="Motivo de envío a Enología"></textarea></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br/>
                    <div class="card" v-if="detailFinish.length > 0">
                        <div class="card-header">
                            <h4>Producto Terminado</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Marca</th>
                                        <th>Mezcla Comercial</th>
                                        <th>Vino</th>
                                        <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        <th>Botella</th>
                                        <th style="width: 3%;"></th>
                                        <th style="width: 30%;">Motivo</th>
                                    </tr>
                                </thead>
                                <tbody v-for="df in detailFinish" :key="df.id">
                                    <tr>
                                        <td>{{df.brand}}</td>
                                        <td v-if="df.comercialMixCode">{{ df.comercialMix }} - {{ df.comercialMixCode }}</td>
                                        <td>{{df.variety}} {{df.valley}} {{df.quality}}</td>
                                        <td>{{df.finalHarvest}}</td>
                                        <td>{{df.quantity}}</td>
                                        <td><input class="form-control" type="checkbox" :id="'check-' + df.id" /></td>
                                        <td><textarea class="form-control"  :id="'reason-' + df.id" placeholder="Motivo de envío a Enología"></textarea></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <button @click="sendEnologySamples" class="btn btn-block btn-success">
                <i class="fa fa-send"></i>
                Enviar
              </button>
            </div>
          </div>
        </div>
    </div>
  </template>
  <script>
    import $ from "jquery";
    export default {
        props: ["detailNew", "detailFinish", "sampleToSendOenology"],
        data() {
            return {
                apiUrl: this.$store.getters.apiUrl,
            };
        },
        methods: {
            sendEnologySamples() {
                this.detailNew.forEach(itemNew => {
                    let is_checked = $("#check-"+ itemNew.id).is(':checked')
                    if (is_checked)  {
                        itemNew.wineSample = true;
                        itemNew.reasonOenologySended = $("#reason-"+ itemNew.id).val();
                    }
                    
                });
                this.detailFinish.forEach(itemFinish => {
                    let is_checked = $("#check-"+ itemFinish.id).is(':checked')
                    if (is_checked){
                        itemFinish.wineSample = true;
                        itemFinish.reasonOenologySended = $("#reason-"+ itemFinish.id).val();
                    }
                });
                this.$emit("sendEnologySamples");
            },
        }
    };
  </script>
  